import clsx from 'clsx';

const sizes = {
  xs: 'h-5 w-5 text-[10px]',
  sm: 'h-6 w-6 text-xs',
  md: 'h-8 w-8 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-20 w-20 text-2xl',
} as const;

const API = (typeof window !== 'undefined' && (window as any).__API) || (import.meta as any)?.env?.VITE_API_URL || 'https://api.ardacious.app';

export function Avatar({
  name, friendId, hasAvatar, size = 'md', className, version,
}: {
  name: string;
  friendId?: string;
  hasAvatar?: boolean;
  size?: keyof typeof sizes;
  className?: string;
  version?: number; // cache-bust after upload
}) {
  const initials = name.split(' ').filter(Boolean).slice(0, 2).map(n => n[0]).join('').toUpperCase();
  const hash = name.split('').reduce((a, c) => (a + c.charCodeAt(0)) % 100, 0);
  const shade = 30 + (hash % 30);

  if (hasAvatar && friendId) {
    const url = `${API}/avatar/get/${friendId}${version ? `?v=${version}` : ''}`;
    return (
      <img
        src={url}
        alt={name}
        className={clsx('rounded-sm object-cover', sizes[size], className)}
        onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
      />
    );
  }
  return (
    <div
      className={clsx('inline-flex items-center justify-center rounded-sm font-medium text-bg', sizes[size], className)}
      style={{ background: `hsl(0,0%,${shade}%)` }}
      aria-label={name}
    >
      {initials}
    </div>
  );
}
